/**
 * IS THIS CUSTOMER AN ADMINISTRATOR — one rule, read by every component that asks.
 *
 * <h2>Why it reads several fields rather than one</h2>
 *
 * `useAuth()` already derives `isAdmin` from `subscriptionType === 'ADMIN'`, and that is the first
 * thing checked here. But live Firestore documents were written by several code paths over the years
 * and the profile arrives from more than one shape of payload, so a single-field test drops admin
 * privileges for a document that spells it differently. `/api/user/me` serialises the Java `User`
 * with Jackson and `User.isAdmin()` is a public getter, so the JSON carries `admin: true` alongside
 * `subscriptionType`; `role` is accepted too, for documents written by older paths.
 *
 * <h2>Unknown is NOT admin</h2>
 *
 * Every admin-only action is also enforced server-side — the Message Centre's POST returns 403 on
 * its own authority, and the Area Highlight frames are checked at their endpoint. So guessing
 * generously here does not grant anything: it replaces a hidden control with a visible one that
 * fails, which is worse than not offering it.
 *
 * <h2>Extracted rather than copied</h2>
 *
 * This was a private const in `AreaHighlightDialog`. A second copy in the Message Centre would be a
 * second definition of who an administrator is, and the two would drift the first time a payload
 * gained a field — leaving one dialog showing a control the other hid, for the same customer.
 */
export const isAdminUser = (isAdminFlag, user) => {
  if (isAdminFlag) return true;
  if (!user) return false;
  if (user.admin === true) return true;
  const role = String(user.role || user.subscriptionType || '').toUpperCase();
  return role === 'ADMIN';
};

export default isAdminUser;
